import { get, put } from '../request';
import { ApiEndpoints } from '../apiEndpoints.constant';
import type { InsuranceDetails, UpdateInsuranceDetails as UpdateInsuranceDetails } from '@/@types/insurance';
import { APP_CONFIG } from '@/config';

export const getInsuranceDetails = async (): Promise<InsuranceDetails> =>
  await get(`${APP_CONFIG.baseApiUrl}${ApiEndpoints.insuranceDetails}`);

export const updateInsuranceDetails = async (insuranceNumber: string, payload: UpdateInsuranceDetails) => {
  return await put(
    `${APP_CONFIG.baseApiUrl}${ApiEndpoints.insuranceDetails}/${insuranceNumber}`,
    payload,
    'XSRF-TOKEN',
  );
};
